import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import { useDispatch } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import FeatureTable from "../../../components/signup/FeatureTable";

interface ManagePlanUpgradePopupProps {
  title?: string;
  open?: boolean;

  onHide?: () => void;

  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
}
const ManagePlanUpgrade: React.FC<ManagePlanUpgradePopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const closeModel = () => {
    setAlertModelShow(false);
    dispatch(setNotificationAction({ message: [], severity: "info" }));
  };
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("lg"); // Adjust the type definition
  return (
    <Popup
      open={alertModalShow}
      title={"Plans & Pricing"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText sx={{background:'#E5F4F1'}}>
          <Notification />
          <FeatureTable isNew={false} />
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ManagePlanUpgrade;
